export default "__VITE_ASSET__CMyCNtsB__"